/* eslint-disable @typescript-eslint/no-unused-vars */
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import {
  setFormDetails,
  setTopupPacksModalStatus,
} from "../../../../redux/features/shared/sharedSlice";
import { Field, FormikProvider, useFormik } from "formik";
import { Form } from "react-bootstrap";
import FieldInputText from "../common/InputFeilds/InputTextField";
import * as Yup from "yup";
import { REQUIRED } from "../../../../utils/const";
import {
  addTopupPack,
  updateTopupPack,
} from "../../../../redux/features/topupPacks/_topupPacksAction";

function TopupPacksModal() {
  const dispatch: any = useDispatch();
  const sharedActions: any = useSelector((state: any) => state.sharedActions);

  const FormValidation = Yup.object().shape({
    name: Yup.string().required(REQUIRED),
    slug: Yup.string().required(REQUIRED),
    priceEgp: Yup.number().min(0, "Must be 0 or more").required(REQUIRED),
    credits: Yup.number().min(1, "Must be at least 1").required(REQUIRED),
  });

  const formInitialValues = {
    name: sharedActions?.formDetails?.name || "",
    slug: sharedActions?.formDetails?.slug || "",
    priceEgp: sharedActions?.formDetails?.priceEgp || 0,
    discountedPriceEgp: sharedActions?.formDetails?.discountedPriceEgp || "",
    credits: sharedActions?.formDetails?.credits || 0,
    sortOrder: sharedActions?.formDetails?.sortOrder || 0,
    isActive: sharedActions?.formDetails?.isActive !== undefined ? sharedActions?.formDetails?.isActive : true,
  };

  const packFormik: any = useFormik({
    initialValues: formInitialValues,
    validationSchema: FormValidation,
    onSubmit: (values: any, { resetForm }) => {
      const payload = {
        ...values,
        discountedPriceEgp: values.discountedPriceEgp === "" || values.discountedPriceEgp === undefined
          ? null
          : Number(values.discountedPriceEgp),
      };
      if (sharedActions?.formDetails?._id) {
        dispatch(
          updateTopupPack({
            ...payload,
            id: sharedActions.formDetails?._id,
          })
        );
      } else {
        dispatch(addTopupPack({ ...payload }));
      }
      dispatch(setFormDetails({}));
      setTimeout(() => {
        dispatch(setTopupPacksModalStatus(false));
        resetForm();
      }, 500);
    },
    enableReinitialize: true,
  });

  const closeModal = () => {
    dispatch(setTopupPacksModalStatus(false));
    dispatch(setFormDetails({}));
  };

  return (
    <>
      <Modal
        backdrop="static"
        size="lg"
        show={sharedActions.topupPacksModal}
        onHide={closeModal}
        animation={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {!sharedActions.formDetails?._id ? "Add" : "Update"} Credit Pack
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormikProvider value={packFormik}>
            <Form onSubmit={packFormik.handleSubmit} method="POST">
              <div className="row">
                <div className="col-sm-6 col-md-6 mb-6">
                  <Form.Group>
                    <Field
                      name="name"
                      validate={FormValidation}
                      type="text"
                      label="Name"
                      isRequired={true}
                      component={FieldInputText}
                      placeholder="e.g. Small Pack, Large Pack"
                      maxLength={50}
                    />
                  </Form.Group>
                </div>
                <div className="col-sm-6 col-md-6 mb-6">
                  <Form.Group>
                    <Field
                      name="slug"
                      validate={FormValidation}
                      type="text"
                      label="Slug"
                      isRequired={true}
                      component={FieldInputText}
                      placeholder="e.g. small-pack, large-pack"
                      maxLength={50}
                    />
                  </Form.Group>
                </div>
                <div className="col-sm-6 col-md-4 mb-6">
                  <Form.Group>
                    <Field
                      name="priceEgp"
                      validate={FormValidation}
                      type="number"
                      min={0}
                      isRequired={true}
                      label="Price (EGP)"
                      component={FieldInputText}
                    />
                  </Form.Group>
                </div>
                <div className="col-sm-6 col-md-4 mb-6">
                  <Form.Group>
                    <Field
                      name="discountedPriceEgp"
                      validate={FormValidation}
                      type="number"
                      min={0}
                      label="Discounted Price (EGP)"
                      component={FieldInputText}
                    />
                  </Form.Group>
                </div>
                <div className="col-sm-6 col-md-4 mb-6">
                  <Form.Group>
                    <Field
                      name="credits"
                      validate={FormValidation}
                      type="number"
                      min={1}
                      isRequired={true}
                      label="Credits"
                      component={FieldInputText}
                    />
                  </Form.Group>
                </div>
                <div className="col-sm-6 col-md-4 mb-6">
                  <Form.Group>
                    <Field
                      name="sortOrder"
                      validate={FormValidation}
                      type="number"
                      min={0}
                      label="Sort Order"
                      component={FieldInputText}
                    />
                  </Form.Group>
                </div>
                <div className="col-sm-6 col-md-4 mb-6 d-flex align-items-end">
                  <Form.Check
                    type="switch"
                    id="isActive"
                    label="Active"
                    checked={packFormik.values.isActive}
                    onChange={(e) =>
                      packFormik.setFieldValue("isActive", e.target.checked)
                    }
                  />
                </div>
              </div>

              <Modal.Footer>
                <Button
                  type="button"
                  variant="secondary"
                  className="primaryBtn"
                  onClick={closeModal}
                >
                  Cancel
                </Button>
                <Button type="submit" className="primaryBtn active">
                  Submit
                </Button>
              </Modal.Footer>
            </Form>
          </FormikProvider>
        </Modal.Body>
      </Modal>
    </>
  );
}

export { TopupPacksModal };
